import React from "react";
import DashboardSidebar from "./dashboardSidebar";
import { Navigate, Outlet } from "react-router-dom";
import NavbarSection from "../Navbar/NavbarSection";
import { Box } from "@mui/material";

export default function DashboardLayout() {
  if (!localStorage.getItem("admin_token")) {
    return <Navigate to={"/"}></Navigate>;
  }
  return (
    <>
      <div style={{ height: "100vh" }}>
        <div>
          <NavbarSection />
        </div>
        <div style={{ display: "flex" }}>
          <Box sx={{ width: "15%" }}>
            <DashboardSidebar />
          </Box>
          <Box
            sx={{
              height: "100vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
              width: "85%",
            }}
          >
            <Outlet />
          </Box>
        </div>
      </div>
    </>
  );
}
